import React from 'react';

function ForYouRender() {
  return <div>ForYouRender</div>;
}

export default ForYouRender;
